import {useState, useEffect, useRef} from 'react';

const importData = ({files, setCount, addThreadRaw, setTotal}) =>{
  let filtered = [...files].filter(o => o.name.endsWith('.json')).filter(o=>o.name.startsWith('message_'))
  setTotal(filtered.length);
  filtered.forEach((file,key)=>{
    let reader = new FileReader();
    reader.onload = async (event)=>{
      setTimeout(()=>{
        let data = reader.result;
        let json = JSON.parse(data);
        addThreadRaw(json);
        setCount(key+1);
      },10)

    }
    reader.readAsText(file)
  })
}
export default function LandingPage({setAllMessages}){
  const [hoverRef, isHovered] = useHover();
  const [count, setCount] = useState(0);
  const [total, setTotal] = useState(0);
  const [threads, addThread] = useState([]);
  let rawThreads = [];
  const addThreadRaw = (thread) =>{ //like a reducer to not have reflows
    addThread(threads=>[...threads, thread]);
  }

  useEffect(()=>{
    if(count===total){
      for(let i=0; i<threads.length;i++){
        let thread = threads[i];
        let mergerThreadIndex = threads.findIndex((o, key)=>o.thread_path === thread.thread_path && key!==i)
        if(mergerThreadIndex&&mergerThreadIndex!==-1){
          threads[mergerThreadIndex] = {...threads[mergerThreadIndex], messages:[...threads[mergerThreadIndex].messages, ...thread.messages]}
          threads.splice(i, 1);
          i=i-1;
        }
      }
      setAllMessages(threads);
    }
  },[count, total, threads])
  return (
    <div style={{backgroundColor:'#50C9CE', color:'white', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'space-around', minHeight:'100vh'}}>
      <div style={{textAlign:'center', maxWidth:'50%'}}>
        <h1 style={{fontWeight:'300', padding:'3rem 3rem 1rem 3rem'}}>Hello, and Welcome to <span style={{color:'#EF709D'}}>Facebook Messenger Viz</span></h1>

          <h4 style={{fontWeight:'300', }}>This site takes all of your past information, crunches it and provides some interesting stats. Don't worry -- it's safe and secure. Everything is run on your computer, and I never store anything related to you. You can check my opensource code if you want to make sure, or ask your grandson if he thinks its safe.</h4>

      </div>

      <div style={{ maxWidth:'50%', paddingBottom:'8rem', alignItems:'center', flexDirection:'column',display:'flex'}}>
        <h2 style={{textAlign:'center'}}>Let's get started!</h2>
        <h3 style={{fontWeight:'300', padding:'0rem 0rem 4rem 0rem'}}>
          <ol>
            <li>Download Facebook Data: Go to <a target="_blank" href='https://www.facebook.com/dyi/'>https://www.facebook.com/dyi/</a></li>
            <li>Select: DateRange: All time, Format: JSON, Media Quality: High</li>
            <li>Select the Deselect all button</li>
            <li>Click only on messages</li>
            <li>Hit the Create File button</li>
            <li>Wait a day or two</li>
            <li>Return to <a target="_blank" href='https://www.facebook.com/dyi/'>https://www.facebook.com/dyi/</a> and download</li>
            <li>Unzip the file: It will be a single zip with two zips inside of it.</li>
            <li>Unzip the second zip (doesn't have photos in the photos folder)</li>
            <li>Upload the messages folder below!</li>
          </ol>
        </h3>
        <div>
          <label for="file" style={{cursor:'pointer', color:'white', backgroundColor:isHovered?('grey'):('#EF709D'), padding:'1rem', fontWeight:'200', transition:'250ms'}} ref={hoverRef}>Upload</label>
          <input id="file" type="file" name="file" style={{display:'none'}}onChange={(event)=>{importData({files:event.target.files, setCount, addThreadRaw, setTotal})}} directory="" webkitdirectory=""/>

        </div>
        <div>
        {total!==0&&
          <h2 style={{textAlign:'center', fontWeight:'300', padding:'2rem'}}>
            <span style={{color:'#EF709D'}}>{count}</span> / {total}
          </h2>
        }
        </div>
      </div>

    </div>
  )
}
function useHover() {
  const [value, setValue] = useState(false);

  const ref = useRef(null);

  const handleMouseOver = () => setValue(true);
  const handleMouseOut = () => setValue(false);

  useEffect(
    () => {
      const node = ref.current;
      if (node) {
        node.addEventListener('mouseover', handleMouseOver);
        node.addEventListener('mouseout', handleMouseOut);

        return () => {
          node.removeEventListener('mouseover', handleMouseOver);
          node.removeEventListener('mouseout', handleMouseOut);
        };
      }
    },
    [ref.current] // Recall only if ref changes
  );

  return [ref, value];
}
